import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { useSession } from "./shell/session";
import { LoginPage } from "./shell/LoginPage";
import { Shell } from "./shell/Shell";
import { HomePage, SearchPage } from "./modules/home/HomePage";
import { PlanCreatePage, ServicesPage } from "./modules/services/ServicesPage";
import { PlanEditorPage } from "./modules/services/PlanEditorPage";
import { SongEditorPage, SongsPage } from "./modules/songs/SongPages";
import { StandPage } from "./modules/stand/StandPage";
import { GroupPage, GroupsPage, MessagesPage, PeoplePage, PersonPage, TasksPage, WorkflowsPage } from "./modules/community/CommunityPages";
import { CalendarPage, CheckInPage, EventPage, GivingPage, PortalPage, PublicSignupPage, PublishingPage, RegistrationAdminPage, RegistrationsPage } from "./modules/operations/OperationsPages";
import { SettingsPage } from "./modules/settings/SettingsPage";
import { MusicStandHomePage } from "./modules/stand/MusicStandHomePage";

const nativeApp = Capacitor.isNativePlatform();

function SignedStand() {
  const { user, loading } = useSession();
  if (loading) return <section className="page">Opening the stand…</section>;
  if (!user) return <Navigate to="/" replace />;
  return <StandPage />;
}

function Gate() {
  const { user, loading } = useSession();
  if (loading) return <section className="page">Opening MB Live…</section>;
  if (!user) return <LoginPage />;
  if (nativeApp && window.location.pathname === "/") return <Navigate to="/music-stand" replace />;
  return <Shell />;
}

function MusicStandGate() {
  const { user, loading } = useSession();
  if (loading) return <section className="page">Opening MB Music Stand…</section>;
  if (!user) return <LoginPage />;
  return <MusicStandHomePage />;
}

function SongEditorRoute() {
  const { songId } = useParams();
  return <SongEditorPage key={songId ?? "new"} />;
}

export function App() {
  return (
    <Routes>
      <Route path="/stand/:planId" element={<SignedStand />} />
      <Route path="/music-stand" element={<MusicStandGate />} />
      <Route path="/r/:slug" element={<PublicSignupPage />} />
      <Route element={<Gate />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/new" element={<PlanCreatePage />} />
        <Route path="/services/:planId" element={<PlanEditorPage />} />
        <Route path="/songs" element={<SongsPage />} />
        <Route path="/songs/:songId" element={<SongEditorRoute />} />
        <Route path="/people" element={<PeoplePage />} />
        <Route path="/people/:personId" element={<PersonPage />} />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/:groupId" element={<GroupPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/workflows" element={<WorkflowsPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/calendar/:eventId" element={<EventPage />} />
        <Route path="/registrations" element={<RegistrationsPage />} />
        <Route path="/registrations/:registrationId" element={<RegistrationAdminPage />} />
        <Route path="/check-in" element={<CheckInPage />} />
        <Route path="/giving" element={<GivingPage />} />
        <Route path="/publishing" element={<PublishingPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
